import {ModelService} from 'vue-rest-client'
import config from './config'
import AppLoader from '@/app-loader'

const options = {
  httpClientOptions: {
    baseURL: config.baseDisasterUrl,
    getVueInstance: () => {
      return AppLoader.getInstance()
    }
  },
  pk: 'id',
  raw: true
}

export default new ModelService('api/v1/collections/providers/items', 'menu', options)


